import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const CardFill = ({ width = 26, height = 26, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.458 2.70801C20.5625 2.70801 21.4578 3.60359 21.458 4.70801V21.292C21.4578 22.3964 20.5625 23.292 19.458 23.292H8.29199C7.18753 23.292 6.29217 22.3964 6.29199 21.292V4.70801C6.29217 3.60359 7.18753 2.70801 8.29199 2.70801H19.458ZM13.292 7.04199C13.0158 7.04199 12.792 7.26585 12.792 7.54199V10.333C12.792 10.6092 13.0158 10.833 13.292 10.833H15.542C15.818 10.8328 16.042 10.609 16.042 10.333V7.54199C16.042 7.26596 15.818 7.04217 15.542 7.04199H13.292Z"
        fill={fill}
      />
    </Svg>
  );
};

export default CardFill;
